import { ApiProperty } from "@nestjs/swagger";

export class ModuleIdRequest {
    @ApiProperty()
    moduleId: number;
    @ApiProperty()
    username?: string;

    constructor(moduleId: number, username?: string) {
        this.moduleId = moduleId;
        this.username = username;
    }
}